import { i18nFilter } from "app/filters/i18nFilter";
import {
    ImageStyle,
    NoDataContainer,
    NoDataTextPrimary,
    NoDataTextSecondary,
} from "app/pages/industry-analysis/overview/components/MarketDistribution/MarketDistributionStyles";
import { SWReactIcons } from "@similarweb/icons";

export const MarketDistributionNoData = () => {
    const primaryText = i18nFilter()("market.analysis.industry.overview.market.distribution.empty.state.primary");
    const secondaryText = i18nFilter()("market.analysis.industry.overview.market.distribution.empty.state.secondary");

    return (
        <NoDataContainer>
            <ImageStyle>
                <SWReactIcons iconName={"no-data-lab-2"} />
            </ImageStyle>
            <NoDataTextPrimary>{primaryText}</NoDataTextPrimary>
            <NoDataTextSecondary>{secondaryText}</NoDataTextSecondary>
        </NoDataContainer>
    );
};
